import { graphql } from "~/gql";

export const FIND_SIMILAR_EXTERNAL_MATTERS_FOR_MATTERS = graphql(/* GraphQL */ `
  query FindSimilarExternalMattersForMatters($input: FindSimilarExternalMattersForMattersInput!) {
    findSimilarExternalMattersForMatters(input: $input) {
      results {
        matterId
        externalMatters {
          id
          title
          clientId
          client {
            id
            name
            externalReference
          }
          organisationalUnit {
            id
            name
          }
          relevanceScore
          externalCreatedAt
        }
      }
    }
  }
`);
